// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Password-module-container-JogCe{display:flex;flex-direction:column;gap:var(--des-dimension-gap-and-padding-field-between-label-and-box)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Password-module-container-JogCe"
};
export default ___CSS_LOADER_EXPORT___;
